import type { LiveUpdateMessage } from '@evidia/shared';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useSocketStore } from '../stores/SocketStore';

type CallbackFn = (data: any) => void;

type FunctionKey = LiveUpdateMessage['key'] | Array<LiveUpdateMessage['key']>;

function generateKeysMap(functionKey: FunctionKey) {
	if (Array.isArray(functionKey)) {
		return functionKey.reduce((acc, key) => ({ ...acc, [key]: uuidv4() }), {}) as Record<
			LiveUpdateMessage['key'],
			string
		>;
	}

	return { [functionKey]: uuidv4() } as Record<LiveUpdateMessage['key'], string>;
}

export const useSocketMessage = (functionKey: FunctionKey, callback: CallbackFn) => {
	const addFunction = useSocketStore(state => state.addFunction);
	const removeFunction = useSocketStore(state => state.removeFunction);

	useEffect(() => {
		const keysMap = generateKeysMap(functionKey);

		Object.entries(keysMap).forEach(([fK, key]) => {
			addFunction(fK as LiveUpdateMessage['key'], { key, fn: callback });
		});

		return () => {
			Object.entries(keysMap).forEach(([fK, key]) => {
				removeFunction(fK as LiveUpdateMessage['key'], key);
			});
		};
	}, []);
};
